import { useEffect } from "react";
import api from "../../lib/api";

// Injects a JSON-LD <script> that overrides / complements the site-wide
// MedicalClinic aggregateRating with the LATEST live values from Google
// (rating + reviewCount).  Mounted once at the Layout level, so Google's
// crawler always sees the current numbers — not a hardcoded snapshot that
// drifts as new reviews come in.
//
// The script tag has a stable id so successive renders replace rather than
// duplicate it.  If the API is unavailable we do nothing (the static
// aggregateRating already emitted from lib/schema.js remains in place).

const LiveAggregateRatingSchema = () => {
  useEffect(() => {
    let cancelled = false;
    api
      .get("/reviews/google")
      .then((r) => {
        if (cancelled) return;
        const rating = r.data?.rating;
        const count = r.data?.review_count;
        if (!rating || !count) return;
        const jsonld = {
          "@context": "https://schema.org",
          "@type": "MedicalClinic",
          "@id": "https://shantanunetralaya.com/#organization",
          name: "Shantanu Netralaya Eye Hospital",
          url: "https://shantanunetralaya.com/",
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: String(rating),
            reviewCount: String(count),
            bestRating: "5",
            worstRating: "1",
          },
        };
        let el = document.getElementById("jsonld-live-rating");
        if (!el) {
          el = document.createElement("script");
          el.id = "jsonld-live-rating";
          el.type = "application/ld+json";
          document.head.appendChild(el);
        }
        el.textContent = JSON.stringify(jsonld);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
  return null;
};

export default LiveAggregateRatingSchema;
